import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import api, { fmtErr } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Card } from "../components/ui/card";
import { ShieldCheck } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState(localStorage.getItem("cc_login_email") || "");
  const [password, setPassword] = useState("");
  const [remember, setRemember] = useState(!!localStorage.getItem("cc_login_email"));
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const [forgot, setForgot] = useState(false);
  const [msg, setMsg] = useState("");
  const forgotSend = async () => {
    setLoading(true); setErr("");
    try { const r = await api.post("/auth/forgot-password", { email }); setMsg(r.data.messaggio); }
    catch (e) { setErr(fmtErr(e.response?.data?.detail) || e.message); }
    finally { setLoading(false); }
  };

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      await login(email, password, remember);
      if (remember) localStorage.setItem("cc_login_email", email); else localStorage.removeItem("cc_login_email");
      nav("/");
    }
    catch (e) { setErr(fmtErr(e.response?.data?.detail) || e.message); }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex">
      <div className="hidden lg:flex flex-col justify-between w-1/2 bg-primary text-primary-foreground p-12"
        style={{ backgroundImage: "linear-gradient(rgba(15,30,55,0.82),rgba(15,30,55,0.92)), url('https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=1200')", backgroundSize: "cover", backgroundPosition: "center" }}>
        <div className="flex items-center gap-3"><ShieldCheck className="w-9 h-9 text-accent" /><span className="font-display font-bold text-2xl">Capital Control</span></div>
        <div>
          <h1 className="font-display font-bold text-5xl leading-tight">Real Estate Operations<br />& Investment Management</h1>
          <p className="text-white/70 mt-4 text-lg max-w-md">Il centro di controllo unico per operazioni immobiliari, associati in partecipazione, cassa e cantieri.</p>
        </div>
        <div className="text-white/50 text-sm">© 2026 Capital Control</div>
      </div>
      <div className="flex-1 flex items-center justify-center p-6 bg-background">
        <Card className="w-full max-w-md p-8">
          <h2 className="font-display font-bold text-2xl text-primary">Accedi</h2>
          <p className="text-sm text-muted-foreground mb-6">Inserisci le tue credenziali per continuare</p>
          <form onSubmit={submit} className="space-y-4">
            <div><Label>Email</Label><Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" /></div>
            <div><Label>Password</Label><Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" /></div>
            <label className="flex items-center gap-2 text-sm cursor-pointer select-none">
              <input type="checkbox" checked={remember} onChange={(e) => setRemember(e.target.checked)} className="h-4 w-4 accent-primary" data-testid="login-remember" />
              Ricordami su questo dispositivo (30 giorni)
            </label>
            {err && <div className="text-sm text-destructive bg-destructive/10 rounded-lg px-3 py-2" data-testid="login-error">{err}</div>}
            <Button type="submit" className="w-full" disabled={loading} data-testid="login-submit">{loading ? "Accesso..." : "Accedi"}</Button>
          </form>
          <div className="mt-4 text-center">
            {!forgot ? <button type="button" className="text-sm text-primary underline" onClick={() => { setForgot(true); setMsg(""); }} data-testid="login-forgot-btn">Password dimenticata?</button> : (
              <div className="text-left space-y-2 border-t pt-4" data-testid="login-forgot-form">
                <Label>Ti inviamo un link per impostare una nuova password (valido 1 ora)</Label>
                <Input type="email" placeholder="La tua email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-forgot-email" />
                <div className="flex gap-2"><Button type="button" className="flex-1" disabled={loading || !email} onClick={forgotSend} data-testid="login-forgot-submit">Invia link</Button><Button type="button" variant="outline" onClick={() => setForgot(false)}>Annulla</Button></div>
                {msg && <div className="text-sm text-emerald-700 bg-emerald-50 rounded-lg px-3 py-2" data-testid="login-forgot-msg">{msg}</div>}
              </div>)}
          </div>
        </Card>
      </div>
    </div>
  );
}
